export class AlertHistoryResponeModel {
    public fromAlertHistory = true;
    public SYMBOL = '';
    public DESCRIPTION = '';
}